import './styles.scss'
import React, { useContext, useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { useTranslation } from 'react-i18next'
import CustomDropdown from 'Components/CustomDropdown'
import { popupIcon } from 'Assets/Icons'
import apiAdapterCoffeeWeb from 'Services/apiAdapter_CoffeeWeb'
import { CoffeeWebContext } from 'Context/CoffeeWebContext'
import { commonMethods } from 'Utils/commonMethods'
import { getLocalUserDetails } from 'Utils/LocalStorage_Handler'
import { ROUTE_STRINGS } from 'Utils/Constants'
import DialogUIModal from 'Components/UIComponent/DialogUIModal'

const CountryWiseProductionReport = ({ menuLock }) => {
  const { t } = useTranslation()
  const { setLoading } = useContext(CoffeeWebContext)
  const userDetails = getLocalUserDetails()
  const history = useHistory()
  const location = useLocation()
  const fullPath = location.pathname

  const { checkForUserAccess } = commonMethods

  if (userDetails?.id && ROUTE_STRINGS.coffeeReports !== fullPath) {
    history.replace({ pathname: ROUTE_STRINGS.coffeeReports })
  }

  const allCountriesOption = { id: 0, nicename: 'All Countries', flagsUrl: 'https://coffeeweb.s3.ap-south-1.amazonaws.com/Logo+Mark.png' }
  const [historicalDataRemarks, setHistoricalDataRemarks] = useState('')
  const [reportType, setReportType] = useState('Millions Bags')
  const [countriesList, setCountriesList] = useState([])
  const [reportData, setReportData] = useState([])
  const [selectedCountry, setSelectedCountry] = useState(allCountriesOption)
  const [selectedRowData, setSelectedRowData] = useState(null)
  const [showHistoricalDataModal, setShowHistoricalDataModal] = useState(false)

  useEffect(() => {
    getCountryWiseReport()
  }, [])

  const getCountryWiseReport = async (countryId) => {
    setLoading(true)

    try {
      const response = await apiAdapterCoffeeWeb.getCountryWiseProductionReport(countryId || 0)

      const reportData = response?.data?.returnLst || []

      const countryData = reportData?.countryList?.map((ele) => ({
        ...ele,
        id: ele?.id,
        nicename: ele?.nicename,
        flagsUrl: `https://coffeeweb.s3.ap-south-1.amazonaws.com/Masters/Flags/${ele?.iso3}.svg`
      }))

      const updatedCountriesList = [allCountriesOption, ...countryData]

      setCountriesList(updatedCountriesList || [])
      setReportData(reportData || [])
    } catch {
      setLoading(false)
    } finally {
      setLoading(false)
    }
  }
  const handleCountryChange = (event) => {
    const { value } = event

    setSelectedCountry(value)
    getCountryWiseReport(value?.id)
  }

  const toggleSwapOption = () => {
    setReportType((prevOption) => {
      if (prevOption === 'Millions Bags') return 'Metric Tons'
      if (prevOption === 'Metric Tons') return '60 KG Bags'

      return 'Millions Bags'
    })
  }

  const convertToBags = (value) => {
    if (value === '' || Number.isNaN(Number(value))) {
      return ''
    }
    const result = value * 1000000

    return Math.round(result) || ''
  }

  const convertToMt = (valueInMillion) => {
    if (!valueInMillion || Number.isNaN(Number(valueInMillion))) {
      return ''
    }

    const result = valueInMillion * 60000

    return result || ''
  }

  const valueInMillions = (value) => {
    if (value === '' || Number.isNaN(Number(value))) {
      return ''
    }

    return value.toFixed(2) || ''
  }

  const displayValue = (value) => {
    if (reportType === 'Millions Bags') {
      return valueInMillions(value)?.toLocaleString()
    }

    if (reportType === 'Metric Tons') {
      return convertToMt(Math.round(value))?.toLocaleString()
    }

    if (reportType === '60 KG Bags') {
      return convertToBags(value)?.toLocaleString()
    }

    return valueInMillions(value)?.toLocaleString()
  }

  const openHistoryDataModal = (rowData, remarks) => {
    setHistoricalDataRemarks(remarks || '')
    setSelectedRowData(rowData)
    setShowHistoricalDataModal(true)
  }

  const renderHistoryData = () => {
    if (!selectedRowData) {
      return <div>{t('NO_DATA_FOUND')}</div>
    }

    return (
      <div className="historical-data-content">
        <table className="historical-data-table">
          <thead className="historical-data-table-header">
            <tr>
              <th>{t('MONTH')}</th>
              <th>{t('ROBUSTA')}</th>
              <th>{t('ARABICA')}</th>
              <th>{t('EXPORTS')}</th>
            </tr>
            <tr className="table-row-empty"></tr>
          </thead>
          <tbody>
            <tr>
              <td>{selectedRowData?.year}</td>
              <td>{selectedRowData?.robusta}</td>
              <td>{selectedRowData?.arabica}</td>
              <td>{selectedRowData?.exports}</td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }

  const renderFooterContent = () => (
    <div className="historical-data-footer">
      <div className="remarks-label">{t('REMARKS')}</div>
      <div className="remarks-value">
        {t('NOTE')}
        {historicalDataRemarks || '--'}
      </div>
    </div>
  )

  return (
    <div className="country-wise-production-report">
      <div className="production-report-header">
        <div className="production-report-dropdown">
          <CustomDropdown value={selectedCountry} options={countriesList} optionLabel={'nicename'} placeholder={countriesList?.length ? t('SELECT_COUNTRY') : t('NO_DATA_FOUND')} onChange={handleCountryChange} showFlags={true} className="country-selector-dropdown" panelClassName="production-country-selector-panel" />
        </div>
        <div className="production-report-title">{t('YEARLY_WISE_REPORT')}</div>
        <div className="production-report-swap-report" onClick={toggleSwapOption}>
          {reportType}
          <div className="swap-icon">
            <i className="pi pi-angle-up upper-arrow" />
            <i className="pi pi-angle-down down-arrow" />
          </div>
        </div>
      </div>
      <div className="production-report-table-container">
        {reportData?.data?.map((item, index) => (
          <div className="production-report-content" key={index}>
            <table className="production-report-table">
              <thead className="production-report-table-header">
                <tr className="country-name-row">
                  <td colSpan={6}>
                    <div className="country-name-wrapper">
                      <div className="country-name-flag-wrapper">
                        <img src={item?.iso3 ? `https://coffeeweb.s3.ap-south-1.amazonaws.com/Masters/Flags/${item.iso3}.svg` : 'https://coffeeweb.s3.ap-south-1.amazonaws.com/Logo+Mark.png'} alt={item?.countryName} className={`country-flag ${item?.iso3 ? '' : 'default-flag'}`} />
                        <span>{item?.countryName}</span>
                      </div>
                    </div>
                  </td>
                </tr>

                <tr className="sticky-row">
                  <th className="year">{t('YEAR')}</th>
                  <th className="total-production">{t('TOTAL_PRODUCTION')}</th>
                  <th className="arabica">{t('ARABICA')}</th>
                  <th className="robusta">{t('ROBUSTA')}</th>
                  <th className="exports">{t('EXPORTS')}</th>
                  <th className="domestic">{t('DOMESTIC_CONSUMPTION')}</th>
                </tr>

                <tr className="table-row-empty"></tr>
              </thead>

              <tbody style={checkForUserAccess(menuLock)}>
                {item?.reportData?.map(({ year, arabica, consumptions, exports, robusta, totalProduction }, rowIndex, item) => (
                  <React.Fragment key={rowIndex}>
                    <tr>
                      <td style={{ minWidth: '200px' }}>
                        <div
                          className="popup-wrapper"
                          // commented for the future reference of historical data popup implementation
                          //  onClick={() => userDetails && !menuLock && openHistoryDataModal(item?.[rowIndex], reportData?.remarks)}
                        >
                          <div>{year}</div>
                          <div className="icon-wrapper">
                            <img src={popupIcon} alt={year} className="popup-icon" title="popup-icon-image" />
                          </div>
                        </div>
                      </td>
                      <td style={{ minWidth: '200px' }}>{displayValue(totalProduction) || '--'}</td>
                      <td style={{ minWidth: '200px' }}>{displayValue(arabica) || '--'}</td>
                      <td style={{ minWidth: '200px' }}>{displayValue(robusta) || '--'}</td>
                      <td style={{ minWidth: '200px' }}>{displayValue(exports) || '--'}</td>
                      <td style={{ minWidth: '200px' }}>{displayValue(consumptions) || '--'}</td>
                    </tr>
                  </React.Fragment>
                ))}
                <tr className="no-data-row"></tr>
              </tbody>
            </table>
          </div>
        ))}
      </div>

      <DialogUIModal title={t('HISTORICAL_DATA')} showModal={showHistoricalDataModal} handleClose={() => setShowHistoricalDataModal(false)} bodyContent={renderHistoryData} footerContent={renderFooterContent} titlePosition="center" size="lg" customClassName="historical-data-content" />
    </div>
  )
}

export default CountryWiseProductionReport
